import { App, Card, Space } from "antd";
import { useState, type FC } from "react";
import Metadata from "./metadata";
import Metrics from "./metrics";
import type { ItemInfoCardsType } from "./ItemInfoCardsType";
import ActionButton from "../../../masterComponents/actionButton";
import { useTabsContext } from "../../../../contexts/tabsContext";
import { TbReload } from "react-icons/tb";
import { LuShare } from "react-icons/lu";
import { properties } from "../../../../entities/properties";
import Icon from "../../../masterComponents/Icon";
import "./itemInfoCards.css";
import { useCommonPropertiesContext } from "../../../../contexts/commonPropertiesContext";
import { PHRASES_DICTIONARY } from "../../../../entities/phrasesDictionary";

const ItemInfoCards: FC<ItemInfoCardsType> = ({ displayedValuesWithPositions, metadataInfo, handleClickReload, currentBatch }) => {

    const { message: messageApi } = App.useApp();

    const [activeTab, setActiveTab] = useState("metadata");

    const [visibleMetrics, setVisibleMetrics] = useState(false);

    const { id } = useTabsContext();
    const { choosedBatchToQA } = useCommonPropertiesContext();

    const tabList = [
        { key: "metadata", tab: "Metadata" },
        // { key: "metrics", tab: "Metrics" },
    ];

    const contentList = {
        metadata: metadataInfo && <Metadata displayedValuesWithPositions={displayedValuesWithPositions} metadataInfo={metadataInfo} />
        //  metrics: <Metrics finalValuesPositions={"finalValuesPositions"} visibleMetrics={visibleMetrics} />,
    };

    const handleTabChange = (key: string) => {
        setVisibleMetrics(key === "metrics");
        setActiveTab(key);
    };

    const handleClickShare = async () => {
        const copedLink = `${properties.apiHost}/?batch=${choosedBatchToQA}&_id=${id}`;
        try {
            await navigator.clipboard.writeText(copedLink);
            messageApi.success(PHRASES_DICTIONARY.SUCCESS.copy_link);
        } catch (err) {
            messageApi.error(`Error: ${err.message || err}`);
        }
    };
    return (
    <>
         <Card
            title={
                <Space style={{ display: "flex", justifyContent: "space-between" }}>
                    <Space style={{ gap: "var(--spacing-lg)" }}>
                        <span> Data Batch: {choosedBatchToQA} </span>
                        <span> Equipment Number: {metadataInfo?.asset} </span>
                        <span>Equipment Tag: {metadataInfo?.tag}</span>
                    </Space>
                    <div style={{ display: "flex", gap: "var(--spacing-sm)" }}>
                        <ActionButton text="Reload"
                            className="primary-btn-color"
                            onClick={handleClickReload}
                            icon={<Icon icon={TbReload} />}
                            iconPosition="end"
                        />
                        {id && <ActionButton text="Share"
                            className="primary-btn-color"
                            onClick={handleClickShare}
                            icon={<Icon icon={LuShare} />}
                            iconPosition="end"
                        />}
                    </div>
                    {/* {tags &&
                        tags.map(tag => {
                            let color = null;
                            switch (tag) {
                                case "annotated":
                                    color = "blue";
                                    break;
                                case "verified":
                                    color = "green";
                                    break;
                                case "partially verified":
                                    color = "orange";
                                    break;
                                default:
                                    color = "grey";
                                    break;
                            }
                            return (
                                <Tag color={color} key={tag} style={{ marginRight: 0 }}>
                                    {tag.toUpperCase()}
                                </Tag>
                            );
                        })} */}
                </Space>
            }
            className="primary-card qa-card"
            style={{ border: "none" }}
            bodyStyle={{ padding: 'var(--spacing-md) 0px var(--spacing-xs) 0px' }}
            tabList={tabList}
            activeTabKey={activeTab}
            onTabChange={key => {
                handleTabChange(key);
            }}
        >
            {contentList[activeTab]}
        </Card>
    </>
    );
}

export default ItemInfoCards;
